import React, { useEffect, useState } from "react";
import { SERVICE_CATEGORIES } from "../../data/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -100 });
  else el.scrollIntoView({ behavior: "smooth" });
  window.history.replaceState(null, "", `/services#${id}`);
};

export const ServicesNav = () => {
  const [active, setActive] = useState(SERVICE_CATEGORIES[0].id);

  useEffect(() => {
    const onScroll = () => {
      const line = window.innerHeight * 0.35;
      let current = SERVICE_CATEGORIES[0].id;
      SERVICE_CATEGORIES.forEach((c) => {
        const el = document.getElementById(c.id);
        if (el && el.getBoundingClientRect().top <= line) current = c.id;
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div data-testid="services-subnav" className="sticky top-20 z-30 bg-navy-deep/85 backdrop-blur-xl border-b border-white/10">
      <div className="container-x flex gap-2 overflow-x-auto py-3 -mx-6 px-6 lg:mx-auto lg:px-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {SERVICE_CATEGORIES.map((c) => {
          const Icon = c.icon;
          const isActive = active === c.id;
          return (
            <button
              key={c.id}
              onClick={() => scrollTo(c.id)}
              data-testid={`services-subnav-${c.id}`}
              className={`shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs md:text-sm font-medium border transition-colors duration-200 ${
                isActive ? "bg-brand-orange text-white border-brand-orange" : "bg-white/[0.03] text-slate-300 border-white/10 hover:bg-white/[0.08] hover:text-white"
              }`}
            >
              <Icon size={14} /> {c.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ServicesNav;
